import React from 'react'

import IconButton from '@mui/material/IconButton'

import StikisLogoTiny from 'images/stikis_logo-img_only-small.png'
import PageButtons from './PageButtons'
import PageTitleContainer from './PageTitleContainer'
import AuthenticatedNavigation from '../../../components/AuthenticatedNavigation'

export default function PageMenu({ pageId }) {
  return (
    <React.Fragment>
      <IconButton
        edge='start'
        aria-label='home page'
        sx={{
          paddingRight: '2px',
          color: 'white',
        }}
        size='large'
      >
        <a href='/app/welcome'>
          <img src={StikisLogoTiny} id='stikisLogoTiny' alt='Stikis logo' />
        </a>
      </IconButton>
      <PageTitleContainer key={pageId} pageId={pageId} />
      <PageButtons pageId={pageId} />
      <AuthenticatedNavigation />
    </React.Fragment>
  )
}
